import React from 'react';
import { Link } from 'react-router-dom';
import DigitalMarketing from '../icons/digital-marketing.svg';
import MarketResearch from '../icons/Marketing analysis.svg';
import BrandDevelopment from '../icons/brand development.svg';
import TraditionalMarket from '../icons/traditional marketing.svg';
import AdvertisingMedia from '../icons/advertising and media planning.svg';
import BusinessDevelopment from '../icons/Business Development.svg';
import LeadGeneration from '../icons/lead generation.svg';
import PublicRelation from '../icons/Public Relation.svg';
import CustomerExperience from '../icons/Customer Experiance Inhasment.svg';


const services = [
  {
    icon: DigitalMarketing,
    title: 'Digital Marketing',
    description: 'At WhyMe Solutions, our Digital Marketing service expertly boosts your online presence through tailored strategies. We enhance brand visibility with targeted social media campaigns, optimize SEO to drive organic traffic, and manage SEM for immediate visibility. Our content creation and email campaigns foster engagement and conversions. By leveraging advanced analytics, we continuously refine our approach to ensure impactful results and sustained growth.',
    href: '/digital-marketing'
  },
  {
    icon: MarketResearch,
    title: 'Market Research & Analysis',
    description: 'Our market research and analysis services deliver detailed insights into industry trends, consumer behavior, and competitive landscape. We perform thorough data analysis to guide strategic decision-making and uncover growth opportunities. Precise market insights drive successful business strategies and strengthen competitive advantage.',
    href: '/market-research'
  },
  {
    icon: BrandDevelopment,
    title: 'Brand Development',
    description: 'We focus on brand development to craft a distinctive and impactful brand identity. We work on brand design, positioning, and engagement strategies to build a unified and memorable brand presence. Our methods boost brand recognition and create lasting connections with your audience.',
    href: '/brand-development'
  },
  {
    icon: TraditionalMarket,
    title: 'Traditional Marketing',
    description: 'Our traditional marketing services encompass print advertising, direct mail, and outdoor media to reach a diverse audience. We design compelling materials for business cards, stationery, and company profiles. Effective traditional marketing enhances brand visibility and complements your overall marketing strategy.',
    href:'/traditional-marketing'
  },
  {
    icon: AdvertisingMedia,
    title: 'Advertising & Media Planning',
    description: 'We provide expert advertising and media planning to optimize ad placements and achieve maximum reach. We handle media buying and campaign management with strategic precision. Our services ensure targeted advertising, efficient budget use, and impactful media results.',
    href:'/advertising-media'
  },
  {
    icon: LeadGeneration,
    title: 'Lead Generation',
    description: 'Our team excels in lead generation through targeted Meta ad campaigns and Google Ads. We manage ad performance with Ads Manager and provide comprehensive analytics to refine lead acquisition strategies. Our approach ensures a consistent flow of high-quality leads and measurable success.',
    href:'/lead-generation'
  },
  {
    icon: BusinessDevelopment,
    title: 'Business Development',
    description: 'Our business development services aim to drive sales growth, manage mergers and acquisitions, and oversee project management. We create strategies to expand market presence and enhance operational performance. Effective business development fosters long-term growth and operational success.',
    href:'/business-development'
  },
  {
    icon: PublicRelation,
    title: 'Public Relations',
    description: 'We offer comprehensive public relations services, including event planning, crisis management, and influencer collaborations. Our PR strategies support effective product launches and positive media engagement. Strong public relations enhance your brand’s reputation and build valuable public connections.',
    href:'/public-relation'
  },
  {
    icon: CustomerExperience,
    title: 'Customer Experience Enhancement',
    description: 'We enhance customer experience through detailed analysis of customer journeys and implementation of personalization strategies. We collect and evaluate feedback to refine customer support and satisfaction. Our approach improves overall customer experience, driving loyalty and business success.',
    href:'/customer-experience'
  },
];

const SubServiceSectionMarketing = () => {

  return (
    <section className="bg-white py-12 px-4">
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap -mx-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="w-full md:w-1/2 lg:w-1/4 mb-8"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="flex flex-col justify-between items-center text-center bg-white rounded-lg py-12 px-4 transform transition hover:-translate-y-2 hover:shadow-lg border border-[#13689b] mx-2 h-full">
              <div className="flex-grow">
                <img src={service.icon} alt = {service.title} className='mx-auto' />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-left text-black">{service.description}</p>
              </div>
              <Link to={service.href} className='text-white bg-[#13689b] mt-4 px-3 py-2 rounded-md font-semibold hover:text-[#13689b] hover:bg-white hover:border hover:border-[#13689b]'>Explore Service</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  
  );
};

export default SubServiceSectionMarketing;
